import { render, staticRenderFns } from "./AccessPanel.vue?vue&type=template&id=06f869e8&scoped=true"
import script from "./AccessPanel.vue?vue&type=script&lang=js"
export * from "./AccessPanel.vue?vue&type=script&lang=js"
import style0 from "./AccessPanel.vue?vue&type=style&index=0&id=06f869e8&prod&scoped=true&lang=css"
import style1 from "./AccessPanel.vue?vue&type=style&index=1&id=06f869e8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06f869e8",
  null
  
)

export default component.exports